<template>
	<span class="noSelect" :class="wrapClasses" @click="toggle" @keydown.space="toggle">
		<input type="hidden" :name="name" :value="currentValue" />
		<span :class="innerClasses">
			<slot name="open" v-if="currentValue === trueValue"></slot>
			<slot name="close" v-if="currentValue === falseValue"></slot>
		</span>
		<div v-if="mode == 'switch'" class="switchList tableSys taC curP fSub vaM_E">
			<slot name="switchList"></slot>
		</div>
	</span>
</template>
<script>
function oneOf(value, validList) {
	for (let i = 0; i < validList.length; i++) {
		if (value === validList[i]) {
			return true;
		}
	}
	return false;
}
export default {
	name: "OnOff",
	props: {
		value: {
			type: [String, Number, Boolean],
			default: false,
		},
		trueValue: {
			type: [String, Number, Boolean],
			default: true,
		},
		falseValue: {
			type: [String, Number, Boolean],
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		size: {
			validator(value) {
				return oneOf(value, ["large", "small", "default"]);
			},
		},
		name: {
			type: String,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		mode: {
			//模式：onOff带有背景变化，switch没有背景变化
			type: String,
			default: "onOff",
		},
	},
	data() {
		return {
			currentValue: this.value,
		};
	},
	watch: {
		value(val) {
			if (val !== this.trueValue && val !== this.falseValue) {
				throw "Value should be trueValue or falseValue.";
			}
			this.currentValue = val;
		},
	},
	computed: {
		wrapClasses() {
			return [
				"onOff",
				{
					["onOff-checked"]: this.currentValue === this.trueValue,
					["onOff-disabled"]: this.disabled,
					[`onOff-${this.size}`]: !!this.size,
					["onOff-loading"]: this.loading,
				},
				{ curP: this.mode == "onOff" },
				{
					"onOff-switch": this.mode == "switch",
				},
			];
		},
		innerClasses() {
			return "onOff-inner";
		},
	},
	methods: {
		toggle(event) {
			event.preventDefault();
			if (this.disabled || this.loading) {
				return false;
			}
			const checked = this.currentValue === this.trueValue ? this.falseValue : this.trueValue;
			this.currentValue = checked;
			this.$emit("input", checked);
			this.$emit("on-change", checked);
		},
		setValue: function (val = false) {
			//设置值
			this.currentValue = val;
		},
	},
};
</script>
<style lang="scss" scoped="scoped">
$width: 5.5rem;
$switchWidth: 7rem;
$height: 2.75rem;
$btnWidth: $height - 0.5;
$switchBtnWidth: 3.5rem;
$defBg: $contentBgColor;

.onOff {
	position: relative;
	display: inline-block;
	width: $width;
	height: $width / 2;
	line-height: 1.8rem;
	vertical-align: middle;
	background-color: $defBg;
	border-radius: $width;
	box-shadow: 0 0 2em rgba(#000, 0.25) inset;
	transition: all 0.2s ease-in-out;

	&:active:after {
		width: $btnWidth + 0.25;
	}
	&:after {
		position: absolute;
		top: 0.25rem;
		left: 0.25rem;
		width: $btnWidth;
		height: $btnWidth;
		content: "";
		background-color: #fff;
		border-radius: $btnWidth;
		box-shadow: 0 0 1rem rgba(#000, 0.25);
		transition: left 0.2s ease-in-out, width 0.2s ease-in-out;
	}

	&.onOff-checked {
		background-color: $mainColor;
		&:active:after {
			left: ($width - $btnWidth) - 0.25;
		}
		&:after {
			left: $width / 2 + 0.25;
		}
		&.onOff-switch {
			background-color: $defBg;
			&:active:after {
				left: ($switchWidth - $switchBtnWidth) - 0.25 * 2;
			}
			&:after {
				left: ($switchWidth - $switchBtnWidth) - 0.25;
			}
		}
	}

	&.onOff-switch {
		width: $switchWidth;
		&:active:after {
			width: $switchBtnWidth + 0.25;
		}
		&:after {
			width: $switchBtnWidth;
		}
	}

	.switchList {
		position: relative;
		z-index: 1;
		line-height: 1;
		padding: {
			right: 0.2em;
			left: 0.2rem;
		}
		> * {
			height: $height;
		}
	}
}
.onOff-loading {
	opacity: 0.4;
}
.onOff-inner {
	position: absolute;
	left: 23px;
	font-size: 12px;
	color: #fff;
}
.onOff-inner i {
	position: relative;
	top: -1px;
	width: 12px;
	height: 12px;
	text-align: center;
}
.onOff:before {
	position: absolute;
	top: 3px;
	left: 3px;
	z-index: 1;
	display: none;
	width: 14px;
	height: 14px;
	content: "";
	background-color: transparent;
	border-radius: 50%;
	-webkit-animation: onOff-loading 1s linear;
	animation: onOff-loading 1s linear;
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite;
}
.onOff-loading:before {
	display: block;
}
.onOff:focus {
	outline: 0;
	box-shadow: 0 0 0 2px rgba($mainColor, 0.2);
}
.onOff:focus:hover {
	box-shadow: none;
}
.onOff-small {
	width: 28px;
	height: 16px;
	line-height: 14px;
}
.onOff-small:after {
	width: 12px;
	height: 12px;
}
.onOff-small:active:after {
	width: 14px;
}
.onOff-small:before {
	top: 2px;
	left: 2px;
	width: 10px;
	height: 10px;
}
.onOff-small.onOff-checked:after {
	left: 13px;
}
.onOff-small.onOff-checked:before {
	left: 14px;
}
.onOff-small:active.onOff-checked:after {
	left: 11px;
}
.onOff-large.onOff-checked:after {
	left: 35px;
}
.onOff-large.onOff-checked:before {
	left: 37px;
}
.onOff-large:active.onOff-checked:after {
	left: 23px;
}
.onOff-largeBig {
	width: 68px;
}
.onOff-largeBig:active:after {
	width: 26px;
	width: 30px;
}
.onOff-largeBig.onOff-checked:after {
	left: 47px;
}
.onOff-largeBig.onOff-checked:before {
	left: 37px;
}
.onOff-largeBig:active.onOff-checked:after {
	left: 23px;
}
.onOff-checked .onOff-inner {
	left: 7px;
}
.onOff-checked:before {
	left: 25px;
}
.onOff-disabled {
	cursor: not-allowed;
	opacity: 0.6;
}
.onOff-disabled:after {
	cursor: not-allowed;
	background: #fff;
}
.onOff-disabled .onOff-inner {
	color: #fff;
}
.onOff-disabled.onOff-checked {
	background-color: $mainColor;
	opacity: 0.25;
}
.onOff-disabled.onOff-checked:after {
	background: #fff;
}
.onOff-disabled.onOff-checked .onOff-inner {
	color: #fff;
}
@-webkit-keyframes onOff-loading {
	0% {
		-webkit-transform: rotate(0);
		transform: rotate(0);
	}
	to {
		-webkit-transform: rotate(1turn);
		transform: rotate(1turn);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/OnOff.vue